export const parsePropertyTaxesValue = (value: string): number | null => {
  if (value === 'no min' || value === 'no max') return null;

  // Handle "no property tax"
  if (value === 'no property tax') return 0;

  // Handle values like "$250/year", "1k/year", "20k/year+"
  if (value.includes('k/year')) {
    const match = value.match(/(\d+)k/);
    if (match) {
      const thousands = parseInt(match[1]);
      return value.includes('+') ? thousands * 1000 + 1 : thousands * 1000;
    }
  }

  // Handle "$250/year" format
  const match = value.match(/\$(\d+)/);
  return match ? parseInt(match[1]) : null;
};

/**
 * Format a numeric property taxes value for display
 * @param value - Numeric value or null
 * @param isMin - Whether this is a min or max value
 * @returns Display string like "2k/year", "$250/year", etc.
 */
export const formatPropertyTaxesValue = (value: number | null, isMin: boolean): string => {
  if (value === null) return isMin ? 'no min' : 'no max';
  if (value >= 1000) {
    return `${value / 1000}k/year`;
  }
  return `$${value}/year`;
};
